<div mat-dialog-title>
    รายละเอียดการแบ่งจ่าย
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography">
    <div class="container p-3">
        <div class="row d-flex justify-content-center p-3">
            <div class="col-6">
                <p class="text-left"><b>ยอดที่ต้องชำระ</b></p>
                <p class="text-left text-primary"><b>เรียกเก็บแล้ว</b></p>
                <p class="text-left"><b>ยังไม่ได้เรียกเก็บ</b></p>
            </div>
            <div class="col-6">
                <p class="text-right">
                    <b>{{ listData.Quotation_Sum_Price | number : '1.2-2' }} บาท</b>
                </p>
                <p class="text-right text-primary">
                    <b>{{ listData.Partiel_Price | number : '1.2-2' }} บาท</b>
                </p>
                <p class="text-right">
                    <b>{{ listData.Quotation_Sum_Price - listData.Partiel_Price | number : '1.2-2' }} บาท</b>
                </p>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 p-0">
                <nz-table #groupingTable [nzData]="listData.Invoices" nzBordered nzSize="large"
                    class="table table-striped">
                    <thead>
                        <tr>
                            <th class="text-center">No.</th>
                            <th class="text-center">เลขอ้างอิง</th>
                            <th class="text-center">วันที่</th>
                            <th class="text-center">ยอดรวมก่อนภาษี</th>
                            <th class="text-center">ยอดชำระ</th>
                            <th class="text-center">สถานะ</th>
                            <th class="text-center">ดูใบแจ้งหนี้</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of groupingTable.data; let i = index;">
                            <td class="text-center">{{ i+1 }}</td>
                            <td class="text-center">{{ data.INVOICE_NO }}</td>
                            <td class="text-center">{{ data.CREATE_DATE | dateTime:'shortNoTime' }}</td>
                            <td class="text-center">{{ data.BEFORE_VAT | number : '1.2-2' }}</td>
                            <td class="text-center">{{ data.TOTAL | number : '1.2-2' }}</td>
                            <td class="text-center" *ngIf="data.STATUS === 'Done'">
                                <p class="text-success">สำเร็จ</p>
                            </td>
                            <td class="text-center" *ngIf="data.STATUS === 'Wait'">
                                <p class="lifedi-color">รอชำระ</p>
                            </td>
                            <td class="text-center" *ngIf="data.STATUS === 'Cancel'">
                                <p class="text-danger">ไม่สำเร็จ</p>
                            </td>
                            <td class="text-center">
                                <a (click)="invoice(data.INVOICE_NO, data.QUOTATION_VERSION)">
                                    <img src="assets/invoice.png" alt="" width="25px">
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</mat-dialog-content>